<template>
  <div class="row pb-4">
    <div class="col-12">
      <div class="row">
        <div class="col-sm-12 col-md-5 md-padding">
          <ibox :title="getMainDataTitle()">
            <template slot="tools">
              <!-- <div
                v-if="this.$route.params.env === 'dev' && this.product.prod === 0 || this.$route.params.env === 'dev' && this.product.prod === null"
                v-show="!isHidden"
                class="btn btn-xs btn-info mx-sm-1"
                @click.prevent="syncProduct(); isHidden = !isHidden"
              >
                Dodaj produkt na produkcje
              </div> -->
              <div
                class="btn btn-sm btn-primary"
                @click.prevent="getDateFormShop()"
              >
                Pobierz dane ze sklepu
              </div>
            </template>
            <template slot="content" slot-scope="{ setLoading }">
              <main-data
                ref="mainDataForm"
                slot="content"
                @loading="setLoading"
                type="mainData"
                :product="product"
                :clone="clone"
                :loadingData="loading"
              />
            </template>
          </ibox>
        </div>
        <div class="col-sm-12 col-md-3 md-padding">
          <ibox :title="$t('category')">
            <template slot="content" slot-scope="{ setLoading }">
              <category
                slot="content"
                @loading="setLoading"
                type="categories"
                :categories.sync="product.categories"
                :loadingData="loading"
              />
            </template>
          </ibox>
        </div>
        <div class="col-sm-12 col-md-4 md-padding">
          <ibox :title="$t('category')">
            <template slot="content" slot-scope="{ setLoading }">
              <parameters
                ref="parametersForms"
                slot="content"
                @loading="setLoading"
                type="parameters"
                :parameters.sync="product.parameters"
                :parametersTypes="parametersTypes"
                :parametersList="parametersList"
                :loadingData="loading"
              />
            </template>
          </ibox>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12 col-md-8 p-4 md-padding">
          <langs
            ref="langsForms"
            :langs="this.product.langs"
            :loadingData="loading"
          ></langs>
        </div>
        <div class="col-sm-12 col-md-4 p-4 md-padding">
          <preview ref="categoriesForms" :product.sync="this.product"></preview>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <div
            v-if="checkButtonHidden()"
            class="
              btn
              mx-sm-2 mx-md-0
              my-2
              btn-danger
              d-block d-md-inline-block
            "
            @click.prevent="deleteProduct()"
          >
            Usuń produkt
          </div>
          <div
            type="submit"
            class="
              btn
              mx-md-2
              my-2
              btn-primary
              d-block d-md-inline-block
              float-md-right
            "
            v-text="
              checkButtonHidden()
                ? this.$t('update_product')
                : this.$t('save_product')
            "
            @click.prevent="handleSubmit()"
          ></div>
          <div
            v-if="checkButtonHidden() && this.product.visible === 1"
            class="
              btn
              mx-md-2
              my-2
              btn-warning
              d-block d-md-inline-block
              float-md-right
            "
            @click.prevent="hiddenProduct()"
          >
            {{ $t("hidden_product") }}
          </div>
          <div
            v-if="checkButtonHidden() && this.product.visible === 0"
            class="
              btn
              mx-md-2
              my-2
              btn-info
              d-block d-md-inline-block
              float-md-right
            "
            @click.prevent="showProduct()"
          >
            {{ $t("show_product") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Category from './Categories.vue'
import Langs from './Langs.vue'
import Parameters from './Parameters.vue'
import MainData from './Forms/MainData.vue'
import Preview from './Preview.vue'
import Ibox from '@/components/Ibox'

export default {
  name: 'ProductForm',
  data() {
    return {
      product: {
        image_url: '',
        plum: '',
        ean: '',
        name: '',
        description: '',
        share_url: '',
        circle_image_url: '',
        nail_image_url: '',
        nail_triangle_url: '',
        packshot_url: '',
        trol_id: null,
        visible: 0,
        categories: [],
        parameters: [],
        langs: [],
        prod: 0
      },
      testProduct: {},
      clone: false,
      prepareCatToSave: [],
      loading: true,
      parametersList: [],
      parametersTypes: [],
      syncDataElement: [],
      isHidden: false
    }
  },
  async created() {
    if ( this.$route.params.clone !== undefined ) {
      this.clone = true
    }
    if ( this.$route.params.id !== undefined ) {
      await this.getData()
    } else {
      await this.getCategoryTree()
    }

    await this.getParametersList()
    await this.getParametersTypes()
    console.log( this.product.prod )
  },
  methods: {
    getData() {
      this.$http
        .get( `vnfr/${this.$route.params.env}/products/${this.$route.params.id}` )
        .then( resp => {
          this.product = resp.data.product
          return true
        } )
        .catch( err => {
          this.$toastr.error( err )
        } )
    },
    getParametersList() {
      this.$http
        .get( `vnfr/${this.$route.params.env}/parameters/select-list` )
        .then( resp => {
          this.parametersList = resp.data.data
          return this.parametersList
        } )
        .catch( err => {
          this.$toastr.error( err )
        } )
    },
    getParametersTypes() {
      this.$http
        .post( `vnfr/${this.$route.params.env}/parameters-types/list`, {
          entries: 20
        } )
        .then( resp => {
          this.parametersTypes = resp.data.table.data
          this.loading = false
          return this.parametersTypes
        } )
        .catch( err => {
          this.$toastr.error( err )
          this.loading = false
        } )
    },
    checkButtonHidden() {
      return this.$route.params.id !== undefined && this.clone === false
    },
    checkSync() {
      return this.syncDataElement.length > 0 ? true : false
    },
    checkSyncElement( name ) {
      return this.syncDataElement.includes( name )
    },
    textSyncElement( name ) {
      return this.checkSyncElement( name )
        ? 'Dane pobrane ze sklepu'
        : 'Brak danych w sklepie'
    },
    getDateFormShop() {
      if ( this.product.plum !== '' ) {
        this.syncDataElement = []
        this.loading = true
        this.$http
          .get(
            `vnfr/${this.$route.params.env}/products/from-shop/${this.product.plum}`
          )
          .then( resp => {
            // this.product = resp.data.product;
            this.margeDataFormShop( resp.data.product )
            this.$toastr.success( 'Prawidłowo pobrano dane o produkcie' )
            this.loading = false
            return true
          } )
          .catch( () => {
            this.$toastr.error( 'Brak produktu lub bład podczas pobierania' )
            this.loading = false
          } )
      } else {
        this.$toastr.error( 'Wartość "plum" musi być ustawiona' )
      }
    },
    margeDataFormShop( dataFromProduct ) {
      // console.log("formShop data", dataFromProduct);
      if ( dataFromProduct !== undefined && dataFromProduct !== null ) {
        this.margeMainProductData( dataFromProduct )
        if ( dataFromProduct.parameters.length > 0 ) {
          this.mergeParametersFromShop( dataFromProduct.parameters )
        }
        if ( dataFromProduct.langs.length > 0 ) {
          this.mergeLangsFromShop( dataFromProduct.langs )
        }
        if ( dataFromProduct.categories.length > 0 ) {
          this.product.categories = dataFromProduct.categories
          // this.mergeCategoriesFromShop(dataFromProduct.categories);
        }
      }
    },
    margeMainProductData( product ) {
      if ( product.image_url !== '' ) {
        this.product.image_url = product.image_url
        this.syncDataElement.push( 'image_url' )
      }
      if ( product.plum !== '' ) {
        this.product.plum = product.plum
        this.syncDataElement.push( 'plum' )
      }
      if ( product.ean !== '' ) {
        this.product.ean = product.ean
        this.syncDataElement.push( 'ean' )
      }
      if ( product.share_url !== '' ) {
        this.product.share_url = product.share_url
        this.syncDataElement.push( 'share_url' )
      }
      if ( product.circle_image_url !== '' ) {
        this.product.circle_image_url = product.circle_image_url
        this.syncDataElement.push( 'circle_image_url' )
      }
      if ( product.nail_image_url !== '' ) {
        this.product.nail_image_url = product.nail_image_url
        this.syncDataElement.push( 'nail_image_url' )
      }
      if ( product.nail_triangle_url !== '' ) {
        this.product.nail_triangle_url = product.nail_triangle_url
        this.syncDataElement.push( 'nail_triangle_url' )
      }
      if ( product.packshot_url !== '' ) {
        this.product.packshot_url = product.packshot_url
        this.syncDataElement.push( 'packshot_url' )
      }
      if ( product.visible !== undefined ) {
        this.product.visible = product.visible
        this.syncDataElement.push( 'visible' )
      }
      if ( product.prod !== undefined ) {
        this.product.prod = product.prod
        this.syncDataElement.push( 'prod' )
      }
      if ( product.plum !== '' ) {
        this.product.plum = product.plum
        this.syncDataElement.push( 'plum' )
      }
      if ( product.ean !== '' ) {
        this.product.ean = product.ean
        this.syncDataElement.push( 'ean' )
      }
      if ( product.share_url !== '' ) {
        this.product.share_url = product.share_url
        this.syncDataElement.push( 'share_url' )
      }
      if ( product.circle_image_url !== '' ) {
        this.product.circle_image_url = product.circle_image_url
        this.syncDataElement.push( 'circle_image_url' )
      }
      if ( product.nail_image_url !== '' ) {
        this.product.nail_image_url = product.nail_image_url
        this.syncDataElement.push( 'nail_image_url' )
      }
      if ( product.nail_triangle_url !== '' ) {
        this.product.nail_triangle_url = product.nail_triangle_url
        this.syncDataElement.push( 'nail_triangle_url' )
      }
      if ( product.packshot_url !== '' ) {
        this.product.packshot_url = product.packshot_url
        this.syncDataElement.push( 'packshot_url' )
      }
      if ( product.visible !== undefined ) {
        this.product.visible = product.visible
        this.syncDataElement.push( 'visible' )
      }
    },
    mergeCategoriesFromShop( categoriesFormShop ) {
      if ( categoriesFormShop.length > 0 ) {
        const selectedElementFromShop = []
        categoriesFormShop.forEach( cat => {
          this.getSelectedCategories( cat, selectedElementFromShop )
        } )

        this.product.categories.forEach( cat => {
          this.mergeCategories( cat, selectedElementFromShop )
        } )
      }
    },
    mergeCategories( cat, selectedNew = [] ) {
      if ( cat.selected === false ) {
        if ( selectedNew.includes( cat.id ) === true ) {
          cat.selected = true
        }
      }
      if ( cat.children !== undefined && cat.children.length > 0 ) {
        cat.children.forEach( element => {
          if ( selectedNew.includes( element.id ) === true ) {
            element.selected = true
          }
          if ( element.children !== undefined && element.children.length > 0 ) {
            this.getSelectedCategories( element, selectedNew )
          }
        } )
      }
    },
    getSelectedCategories( cat, selected = [] ) {
      if ( cat.selected === true ) {
        selected.push( cat.id )
      }
      if ( cat.children !== undefined && cat.children.length > 0 ) {
        cat.children.forEach( element => {
          if ( element.selected === true ) {
            selected.push( element.id )
          }
          if ( element.children !== undefined && element.children.length > 0 ) {
            this.getSelectedCategories( element, selected )
          }
        } )
      }
    },
    mergeParametersFromShop( parametersFormShop ) {
      if ( parametersFormShop.length > 0 ) {
        this.product.parameters.forEach( ( param, index ) => {
          const newParam = parametersFormShop.filter(
            p => param.parameter_type_id === p.parameter_type_id
          )
          if ( newParam.length > 0 ) {
            this.product.parameters[ index ] = newParam[ 0 ]
            this.syncDataElement.push( `parameter_${param.parameter_type_id}` )
          }
        } )
      }

      console.log( 'metg parm ', this.product )
    },
    mergeLangsFromShop( langsFormShop ) {
      if ( langsFormShop.length > 0 ) {
        this.product.langs.forEach( lang => {
          const newLang = langsFormShop.filter( l => lang.lang === l.lang )
          if ( newLang.length > 0 ) {
            this.mergeLangFromShop( lang, newLang[ 0 ] )
          }
        } )
      }
    },
    mergeLangFromShop( currentLang, newLang ) {
      if ( newLang.name !== '' ) {
        currentLang.name = newLang.name
        this.syncDataElement.push( `lang_${currentLang.lang}_name` )
      }
      if ( newLang.name_prefix !== '' ) {
        currentLang.name_prefix = newLang.name_prefix
        this.syncDataElement.push( `lang_${currentLang.lang}_name_prefix` )
      }
      if ( newLang.name_suffix !== '' ) {
        currentLang.name_suffix = newLang.name_suffix
        this.syncDataElement.push( `lang_${currentLang.lang}_name_suffix` )
      }
      if ( newLang.description !== '' ) {
        currentLang.description = newLang.description
        this.syncDataElement.push( `lang_${currentLang.lang}_description` )
      }
      const availableData = [
        'od_ręki',
        'right_away',
        'sofort',
        'en_stock',
        'de_inmediato',
        'subito'
      ]
      if ( newLang.application !== '' ) {
        if (
          newLang.application !== '' &&
          newLang.application !== null &&
          newLang.application !== undefined &&
          availableData.includes(
            newLang.application.replace( /\s+/g, '_' ).toLowerCase()
          )
        ) {
          currentLang.application = newLang.application
          this.syncDataElement.push( `lang_${currentLang.lang}_application` )
        }
      }
      if ( newLang.composition !== '' ) {
        currentLang.composition = newLang.composition
        this.syncDataElement.push( `lang_${currentLang.lang}_composition` )
      }
      if ( newLang.visible !== undefined ) {
        currentLang.visible = newLang.visible
        this.syncDataElement.push( `lang_${currentLang.lang}_visible` )
      }
    },
    getMainDataTitle() {
      let title = 'Edycja produktu'
      if ( this.product.plum !== '' ) {
        title = `${title}: ${this.product.plum}`
      }
      return title
    },
    getCategoryTree() {
      this.$http
        .get( `vnfr/${this.$route.params.env}/categories/tree` )
        .then( resp => {
          this.product.categories = resp.data.data
          this.$emit( 'loading', false )
          return true
        } )
        .catch( err => {
          this.$toastr.error( err )
        } )
    },
    deleteProduct() {
      this.$http
        .delete(
          `vnfr/${this.$route.params.env}/products/${this.$route.params.id}`
        )
        .then( () => {
          this.$toastr.success( 'Usunięte!!' )
          this.$router.push(
            `/przymierzalnia/${this.$route.params.env}/produkty`
          )
        } )
        .catch( err => {
          this.$toastr.error( err )
        } )
    },
    prepareDataToSave() {
      const productData = {
        image_url: this.product.image_url,
        plum: this.product.plum,
        ean: this.product.ean,
        share_url: this.product.share_url,
        visible: this.product.visible,
        trol_id: this.product.trol_id,
        description: this.product.description,
        circle_image_url: this.product.circle_image_url,
        nail_image_url: this.product.nail_image_url,
        nail_triangle_url: this.product.nail_triangle_url,
        packshot_url: this.product.packshot_url,
        categories: [],
        parameters: [],
        langs: [],
        prod: this.product.prod
      }
      productData.parameters = this.prepareParametersToSave()
      productData.langs = this.prepareLangsToSave()

      const categories = []
      this.product.categories.forEach( cat => {
        this.prepareCategoryToSave( cat, categories )
      } )

      productData.categories = categories

      return productData
    },
    prepareLangsToSave() {
      const langs = []
      this.product.langs.forEach( l => {
        langs.push( l )
      } )
      return langs
    },
    prepareCategoryToSave( cat, array = [] ) {
      if ( cat.selected === true ) {
        array.push( { id: cat.id } )
      }
      if ( cat.children !== undefined ) {
        cat.children.forEach( element => {
          this.prepareCategoryToSave( element, array )
        } )
      }
    },
    prepareParametersToSave() {
      const parameters = []
      this.product.parameters.forEach( p => {
        if ( p.id !== null && p.id !== undefined ) {
          parameters.push( {
            id: p.id
          } )
        }
      } )
      return parameters
    },
    hiddenProduct() {
      this.loading = true
      this.$http( {
        url: `vnfr/${this.$route.params.env}/products/hidden/${this.$route.params.id}`,
        method: 'patch'
      } )
        .then( () => {
          this.$toastr.success( 'Ukryto produtk' )
          this.loading = false
          this.$router.push(
            `/przymierzalnia/${this.$route.params.env}/produkty`
          )
        } )
        .catch( err => {
          this.$toastr.error( err )
          this.loading = false
        } )
    },
    showProduct() {
      this.loading = true
      this.$http( {
        url: `vnfr/${this.$route.params.env}/products/show/${this.$route.params.id}`,
        method: 'patch'
      } )
        .then( () => {
          this.$toastr.success( 'Produkt widoczny' )
          this.loading = false
          this.$router.push(
            `/przymierzalnia/${this.$route.params.env}/produkty`
          )
        } )
        .catch( err => {
          this.$toastr.error( err )
          this.loading = false
        } )
    },
    handleSubmit() {
      const formValidated = []
      formValidated.push( this.$refs.langsForms.validationForms() )
      formValidated.push( this.$refs.mainDataForm.validationForms() )
      formValidated.push( this.$refs.categoriesForms.$validator.validateAll() )
      formValidated.push( this.$refs.parametersForms.validationForms() )

      Promise.all( formValidated ).then( value => {
        if ( value.includes( false ) ) {
          return false
        } else {
          this.saveProduct()
        }
      } )
    },
    saveProduct() {
      this.loading = true
      const productData = this.prepareDataToSave()
      const url = `vnfr/${this.$route.params.env}/products/${this.$route.params.id}`
      this.$http( {
        url:
          this.$route.params.id !== undefined && this.clone === false
            ? url
            : `vnfr/${this.$route.params.env}/products/`,
        method:
          this.$route.params.id !== undefined && this.clone === false
            ? 'put'
            : 'post',
        data: productData
      } )
        .then( () => {
          this.$toastr.success( 'Zapisane !' )
          this.loading = false
          this.$router.push(
            `/przymierzalnia/${this.$route.params.env}/produkty`
          )
        } )
        .catch( () => {
          this.$toastr.error( 'Błąd podczas zapisu !' )
          this.loading = false
        } )
    },
    syncProduct() {
      if ( this.product.plum !== '' ) {
        this.loading = true
        this.$http( {
          url: `vnfr/products/export/${this.product.plum}`,
          method: 'post'
        } )
          .then( () => {
            this.$toastr.success( 'Produkt został eksportowany na produkcje' )
            this.loading = false
          } )
          .catch( () => {
            this.$toastr.error( 'Coś poszło nie tak' )
            this.loading = false
          } )
      } else {
        this.$toastr.error( 'Wartość "plum" musi być ustawiona' )
      }
    }
  },
  components: {
    MainData,
    Category,
    Parameters,
    Langs,
    Preview,
    Ibox
  }
}
</script>

<style scoped>
a {
  color: white;
}
img {
  max-width: 100px;
  max-height: 100px;
}
.md-padding {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
</style>

<style>
.padding-sm {
  padding-left: 1px !important;
  padding-right: 1px !important;
}
.disable-more-text {
  font-size: 14px;
  color: #a8a5a5;
}
.tooltip {
  position: relative;
  display: inline-block;
  opacity: 1 !important;
}
.tooltip .tooltiptext {
  visibility: hidden;
  background-color: black;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;
  position: absolute;
  z-index: 1;
  width: 120px;
  bottom: 100%;
  left: 50%;
  margin-left: -60px;
}
.tooltip:hover .tooltiptext {
  visibility: visible;
}
</style>
